import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {QccModalComponent} from '../qcc-modal/qcc-modal.component';
import {AnalyticsService} from '../../shared/analytics.service';
import {AuthService} from '../../shared/auth.service';
import {UpdateAssignmentModalComponent} from '../update-assignment-modal/update-assignment-modal.component';
import {EndOfAssignmentEventType} from '../../../model';

@Component({
  selector: 'position-activity',
  templateUrl: './position-activity.component.html',
  styleUrls: ['./position-activity.component.scss']
})
export class PositionActivityComponent {

  @ViewChild('qccModal') qccModal: QccModalComponent;
  @ViewChild('updateAssignmentModal') updateAssignmentModal: UpdateAssignmentModalComponent;

  @Input() order: Order;
  @Input() activityType: string;
  @Input() activityContent: string | null;

  @Output() qccSubmitted = new EventEmitter<void>();
  @Output() assignmentUpdated = new EventEmitter<void>();

  EndOfAssignmentEventType = EndOfAssignmentEventType;
  masquerading$ = this.Auth.masquerading$;

  constructor(private Auth: AuthService,
              private Analytics: AnalyticsService) {
  }

  showQccModal(rating: number) {
    if (this.masquerading$.getValue()) {
      return;
    }
    this.qccModal.show(rating);
  }

  qccSuccess() {
    this.qccSubmitted.emit();
    this.Analytics.trackEvent('Positions: Review submitted');
  }

  updateAssignment(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.updateAssignmentModal.show();
  }

  onAssignmentUpdated() {
    this.assignmentUpdated.emit();
    this.Analytics.trackEvent('Positions: Assignment updated');
  }
}
